import Api from '@/services/ServiceBase'
const path = 'users'

export default {
  addUpdate(user) {
    return Api().post(path, user)
  },
  list(name,userName, page) {
    return Api().get(path, {
      params: {
        name,
        userName,
        page
      }
    })
  },
  show(id) {
    return Api().get(path + `/${id}`)
  },
  delete(id) {
    return Api().delete(path + `/${id}`)
  },
  login(userName,pass)
  {
    return Api().get(path + `/login`,{
        params: {
          userName: userName,
          password: pass
        }
      })
  }
}
